export default {"src":"/_next/static/media/0xb9737098b50d7c536b6416daeb32879444f59fca.7827a245.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};